import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";

import additionHelpers from "@common/components/helpers/addition";
import CustomerFormAction from "@common/redux/actions/CustomerFormAction";
import IdentityFormModalAction from "@common/redux/actions/IdentityFormModalAction";
import {
  filterSelectedCustomerOptions,
  filterUnknownCustomers,
} from "../helpers/Customer/filterCustomers";
import fetchIdentityOptions from "../helpers/Customer/fetchIdentityOptions";
import useIdentityFormModal from "./useIdentityFormModal";
import useCustomerEdit from "./useCustomerEdit";

const useCustomerForm = ({
  handleExists,
  handleNewCustomer,
  handleEditCustomer,
  handleResetCustomer,
  showContacts,
  showCustomerUnknownCheckbox,
}) => {
  const data = useSelector((store) => CustomerFormAction.getStatePath(store));
  const { customers, customersOptions } = data;
  const { isValidPhoto } = useIdentityFormModal();

  const methods = useFormContext();
  const [customerUnknown, hideCustomerSearch] = methods.watch([
    "customerUnknown",
    "hideCustomerSearch",
  ]);

  const { editCustomer } = useCustomerEdit({ handleEditCustomer, customers });

  const handleAddition = () => {
    IdentityFormModalAction.onExists = handleExists;
    IdentityFormModalAction.open(fetchIdentityOptions, handleNewCustomer, {
      title: "Add New Customer",
      hideName: false,
      optionalName: false,
      showContacts: showContacts,
      isEditing: false,
    });
  };

  const addUnknownCustomer = () => {
    IdentityFormModalAction.onClose = handleResetCustomer;
    IdentityFormModalAction.onExists = handleExists;
    IdentityFormModalAction.open(fetchIdentityOptions, handleNewCustomer, {
      title: "Add New Customer",
      hideName: true,
      optionalName: true,
      showContacts: false,
      isEditing: false,
    });
  };

  const { additionLabel, additionButton } = additionHelpers(handleAddition);

  useFilterCustomers(customers, customersOptions);

  return {
    ...data,
    customersOptions: showCustomerUnknownCheckbox
      ? customersOptions
      : filterUnknownCustomers(customersOptions),
    methods,
    customerUnknown,
    handleAddition,
    addUnknownCustomer,
    editCustomer,
    additionLabel,
    additionButton,
    hideCustomerSearch,
    isValidPhoto,
  };
};

export default useCustomerForm;

const useFilterCustomers = (selectedCustomers, allCustomers) => {
  useEffect(() => {
    const unselectedCustomers = filterSelectedCustomerOptions(
      selectedCustomers,
      allCustomers,
    );
    CustomerFormAction.dispatch({
      customersOptions: unselectedCustomers,
    });
  }, [selectedCustomers]);
};
